module.exports = __webpack_public_path__ + "static/media/ctv_nbc_video.851728c8.png";